module.exports = __webpack_public_path__ + "static/img/video_daily_ADV_ok2.01f7642.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/videodaily/video_daily_ADV_ok2.jpg
// module id = YDuK
// module chunks = 1